module.exports = __webpack_public_path__ + "img/MASTER-PIC-L.d9d8011f.png";